import { Link, useLocation, Navigate } from "react-router-dom";
import { Cross, ArrowLeft } from "lucide-react";
import { LandingFooter } from "@/components/LandingFooter";
import { LEGAL_DOCS } from "@/content/legal";

export default function Legal() {
  const slug = useLocation().pathname.replace(/^\/+|\/+$/g, "");
  const doc = LEGAL_DOCS[slug];
  if (!doc) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-white text-gray-900 flex flex-col">
      <header className="sticky top-0 z-30 backdrop-blur bg-white/80 border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-5 py-3 min-h-16 flex flex-wrap gap-3 items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="brand">
            <div className="h-9 w-9 rounded-lg bg-emerald-600 text-white flex items-center justify-center">
              <Cross className="h-5 w-5" strokeWidth={2.5} />
            </div>
            <span className="font-head text-lg font-extrabold tracking-tight">FarmaPresenze</span>
          </Link>
          <Link to="/" data-testid="legal-back" className="text-sm font-semibold text-emerald-700 hover:underline flex items-center gap-1">
            <ArrowLeft className="h-4 w-4" /> Torna alla home
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-14 w-full">
        <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wider">Note legali</p>
        <h1 data-testid="legal-title" className="font-head text-3xl sm:text-4xl font-extrabold mt-2">{doc.title}</h1>
        <p data-testid="legal-updated" className="text-sm text-gray-500 mt-2">Ultimo aggiornamento: {doc.updated}</p>
        <div className="mt-10 space-y-8">
          {doc.sections.map((s, sectionIndex) => (
            <section key={s.h} id={slug === "privacy" && sectionIndex === 3 ? "statuto-lavoratori" : undefined} data-testid={`legal-section-${sectionIndex}`} className="scroll-mt-24">
              <h2 className="font-head text-base md:text-lg font-bold">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="text-sm sm:text-base text-gray-700 leading-relaxed mt-2">{para}</p>
              ))}
            </section>
          ))}
        </div>
      </main>

      <LandingFooter />
    </div>
  );
}
